import { assertEvent } from 'xstate';
import { ActionEventParams } from '../../../../lib/types';
import {
  PaymentMachineEvents,
  SendCreatePaymentMethodParams,
  SendFetchPaymentMethodParams,
  SendFetchPaymentMethodsParams,
} from './types/events';
import { PaymentsContext } from './paymentsMachine';

/**
 * Gets input for fetch payment method actor
 * @param ActionEventParams<PaymentsContext, PaymentMachineEvents>
 * @returns SendFetchPaymentMethodParams
 */
export const getFetchPaymentMethodInput = ({
  event,
}: ActionEventParams<
  PaymentsContext,
  PaymentMachineEvents
>): SendFetchPaymentMethodParams => {
  assertEvent(event, 'SEND_FETCH_PAYMENT_METHOD');

  return event.params;
};

/**
 * Gets input for fetch payment methods actor
 * @param ActionEventParams<PaymentsContext, PaymentMachineEvents>
 * @returns SendFetchPaymentMethodsParams
 */
export const getFetchPaymentMethodsInput = ({
  event,
}: ActionEventParams<
  PaymentsContext,
  PaymentMachineEvents
>): SendFetchPaymentMethodsParams => {
  assertEvent(event, 'SEND_FETCH_PAYMENT_METHODS');

  return event.params;
};

/**
 * Gets input for create payment method actor
 * @param ActionEventParams<PaymentsContext, PaymentMachineEvents>
 * @returns SendCreatePaymentMethodParams
 */
export const getCreatePaymentMethodInput = ({
  event,
}: ActionEventParams<
  PaymentsContext,
  PaymentMachineEvents
>): SendCreatePaymentMethodParams => {
  assertEvent(event, 'SEND_CREATE_PAYMENT_METHOD');

  return event.params;
};
